import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type * as me from '../../../me'
import type { Feature } from '../feature'
import * as gql from '../gql'

export const load = store.effects.create(
  (feature: Feature, meFeature: me.Feature) =>
    feature.actions.load.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        context: meFeature.contexts.selectors.zoneContext.asObservable,
        fromDate: feature.selectors.selectedDate.asObservable,
      })),
      rxjs.mergeMap(({ action, context, fromDate }) =>
        context
          ? gql.queries.pulse
              .executor({
                ...context,
                fromDate:
                  graphql.transformers.AWS_SCALARS.date.getGqlFrom(fromDate),
              })
              .pipe(
                rxjs.map(response =>
                  feature.actions.load.success.from(action).create({
                    request: action.data,
                    response,
                  }),
                ),
                rxjs.catchError(error =>
                  rxjs.of(
                    feature.actions.load.error.from(action).create({
                      error,
                      request: action.data,
                    }),
                  ),
                ),
              )
          : rxjs.of(
              feature.actions.load.cancellation.from(action).create({
                reason: 'Not in a valid zone context',
                request: action.data,
              }),
            ),
      ),
    ),
)
